import { createContext } from 'react';

export interface CategoryContextProps {
    currentCategory: number;
    query: string;
    currentPage: number;
    pageSize: number;
    article?: number;
    setQuery?: (query: string) => void;
}

export const CategoryContext = createContext<CategoryContextProps>({
    currentCategory: -1,
    currentPage: 0,
    pageSize: 100,
    query: ''
});
